import React from 'react';

/**
 * COPPA §312.4(d) nearby link — place next to forms that collect personal information
 * from children (or credential flows children use).
 */
export default function PrivacyNoticeLink({ style, className }: any) {
  return (
    <a
      href="/privacy"
      className={className}
      style={{
        color: '#3256a2',
        fontSize: 12,
        fontWeight: 700,
        textDecoration: 'underline',
        ...style,
      }}
    >
      Privacy Policy
    </a>
  );
}
